import { useLocation, useParams } from 'react-router-dom';

/* We need this HOC to extract params from react router 6 , since most of our code is
in class level component not of React Hooks.*/
// Refrence : https://stackoverflow.com/questions/58548767/react-router-dom-useparams-inside-class-component

export default function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} location={useLocation()} />;
}
